import Vue from "vue";
import router from "./router";
import "./plugins/vuetify";
import App from "./App.vue";
import Chat from "vue-beautiful-chat";
import "firebase/auth";
import { store } from "./store/store";
import axios from "axios";
import VueParticles from "vue-particles";
import VueTour from "vue-tour";

require("vue-tour/dist/vue-tour.css");
Vue.use(VueTour);

Vue.use(VueParticles);

Vue.use(Chat);

Vue.config.productionTip = false;

axios.defaults.baseURL = "https://showroom.privately.swiss/api";
// axios.defaults.baseURL = "http://localhost:5001";

if (process.env.TEXTLABEL_SERVER_URL) {
  axios.defaults.baseURL = process.env.TEXTLABEL_SERVER_URL;
} else if (process.env.NODE_ENV === "development") {
  axios.defaults.baseURL = "http://0.0.0.0:8080/showroom/";
  axios.defaults.timeout = 1000 * 60 * 10;
}
let app;

if (!app) {
  /* eslint-disable no-new */
  app = new Vue({
    render: h => h(App),
    created() {
    },
    router,
    store
  }).$mount("#app");
}
